import { render, staticRenderFns } from "./OrganizationSelection.vue?vue&type=template&id=481ee548&scoped=true&"
import script from "./OrganizationSelection.vue?vue&type=script&lang=js&"
export * from "./OrganizationSelection.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationSelection.vue?vue&type=style&index=0&id=481ee548&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481ee548",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDialog,VDivider,VList,VListItem,VTextField})
